// extracted by mini-css-extract-plugin
export default {"txt-field":"text-field_txt-field__pz69L","multiline-field":"text-field_multiline-field__IUsqb"};